<template>
    <BaseSection
        data-span-all
        class="section--extra-margin content-blocks--text"
        data-width="content"
    >
        <BaseRichText>
            <slot />
        </BaseRichText>
    </BaseSection>
</template>

<style lang="less" scoped>
</style>